import { truncate } from 'lodash'
import dateFormat from 'dateformat'

export default {
  /**
   * https://lodash.com/docs/4.17.4#truncate
   */
  truncate (value, length, omission, separator) {
    length = length || 30
    omission = omission || '.'
    separator = separator || '. '

    return truncate(value, { length, omission, separator })
  },

  /**
   * Format date string
   * @param  {String} date
   * @return {String}
   */
  formatDate (date, format = 'mmmm d, yyyy') {
    return dateFormat(date, format, true)
  },

  /**
   * Remove file extension
   * @param  {String} filename
   * @return {String}
   */
  removeFileExtension (filename) {
    return filename.replace(/\.[^/.]+$/, '')
  }
}



// WEBPACK FOOTER //
// ./app/src/filters/index.js